require('./controllers/active_portion_control.js');
require('./controllers/application.js');
require('./controllers/auto_save.js');
require('./controllers/block_operations.js');
require('./controllers/button.js');
require('./controllers/canvas.js');
require('./controllers/change_palette.js');
require('./controllers/column_operations.js');
require('./controllers/editing.js');
require('./controllers/editing_document.js');
require('./controllers/editor_proxy.js');
require('./controllers/frame_comm_manager.js');
require('./controllers/history_operations.js');
require('./controllers/host.js');
require('./controllers/launch_platform.js');
require('./controllers/loading.js');
require('./controllers/main_tab_panel.js');
require('./controllers/modal.js');
require('./controllers/overlay.js');
require('./controllers/row_operations_controller.js');
require('./controllers/slider_controller.js');
require('./controllers/social_follow.js');
require('./controllers/social_share.js');
require('./controllers/social_share_edit.js');
require('./controllers/template.js');
require('./controllers/toolbar.js');
require('./controllers/upload.js');
require('./controllers/view_options.js');
require('./controllers/close_button.js');
